import { logger } from '../../utilities/logger';
import { errorChecker } from '../../utilities/error_checker';

export class BaseNativeDispatcher<Payload> {
  private readonly dispatcherName: string;
  private readonly isWebkit = Boolean(window?.webkit);
  constructor(dispatcherName: string) {
    this.dispatcherName = dispatcherName;
  }

  get nativeDispatcher() {
    if (this.isWebkit) {
      // @ts-expect-error Expect error since this is a custom property
      return window.webkit.messageHandlers?.[this.dispatcherName];
    }
    // @ts-expect-error Expect error since this is a custom property
    return window?.messageHandlers?.[this.dispatcherName]?.();
  }

  postMessage(payload: Payload) {
    if (!this.nativeDispatcher) {
      logger.error({
        message: `Native dispatcher not available for ${this.dispatcherName}`,
        error: new Error(`Native dispatcher not available for ${this.dispatcherName}`),
      });
      return;
    }

    try {
      if (this.isWebkit) {
        this.nativeDispatcher.postMessage(payload);
      } else {
        //Android only supports passing primitive types and strings.
        this.nativeDispatcher.postMessage(JSON.stringify(payload));
      }
      logger.debug({
        message: `Message successfully sent from ${this.dispatcherName}`,
        extra: { payload },
      });
    } catch (error) {
      logger.error({
        error: errorChecker(error),
        message: `Error sending message to ${this.dispatcherName}`,
      });
    }
  }
}
